import { getAppsyncUrl } from "../authenticate";
import { getAuth } from '../../contexts/authStore';
import {getUserPool} from "../pools/pools";

export async function getAvailabilities(scheduleId: string, startDateUser?: string, endDateUser?: string) {
    if (getUserPool()!.getCurrentUser()) {
        const token = getAuth().idToken!;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                headers: {
                    "Authorization": token
                },
                body: JSON.stringify({
                    query: `query Query {
                getAvailabilities(scheduleId: ${JSON.stringify(scheduleId)}${startDateUser ? ", startDateUser: " + JSON.stringify(startDateUser) : ''}
                ${endDateUser ? ", endDateUser: " + JSON.stringify(endDateUser) : ''})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.getAvailabilities)
            })
        })
    }
}

export async function getDefaultAvailabilities(scheduleId: string, userId?: string) {
    if (getUserPool()!.getCurrentUser()) {
        const token = getAuth().idToken!;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                headers: {
                    "Authorization": token
                },
                body: JSON.stringify({
                    query: `query Query {
                getDefaultAvailabilities(scheduleId: ${JSON.stringify(scheduleId)}${userId ? ", userId: " + JSON.stringify(userId) : ''})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.getDefaultAvailabilities)
            })
        })
    }
}

export async function putAvailability(scheduleId: string, dateUserId: string, availability: string, userId: string, date: string) {
    if (getUserPool()!.getCurrentUser()) {
        const token = getAuth().idToken!;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                headers: {
                    "Authorization": token
                },
                body: JSON.stringify({
                    query: `mutation Mutation {
                putAvailability(scheduleId: ${JSON.stringify(scheduleId)}, dateUserId: ${JSON.stringify(dateUserId)}
                , availability: ${JSON.stringify(availability)}, userId: ${JSON.stringify(userId)}, date: ${JSON.stringify(date)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.putAvailability)
            })
        })
    }
}

export async function putDefaultAvailability(scheduleId: string, dayUserId: string, availability: string, userId: string, defaultDay: string) {
    if (getUserPool()!.getCurrentUser()) {
        const token = getAuth().idToken!;
        return await fetch(
            getAppsyncUrl(),
            {
                method: "post",
                headers: {
                    "Authorization": token
                },
                body: JSON.stringify({
                    query: `mutation Mutation {
                putDefaultAvailability(scheduleId: ${JSON.stringify(scheduleId)}, dayUserId: ${JSON.stringify(dayUserId)}
                , availability: ${JSON.stringify(availability)}, userId: ${JSON.stringify(userId)}, defaultDay: ${JSON.stringify(defaultDay)})
            }`
                }),
            }
        ).then(async (response) => {
            return await response.json().then(async (response) => {
                return JSON.parse(response?.data?.putDefaultAvailability)
            })
        })
    }
}
